import _ from "lodash";
import { getValue } from "../../../common/getValue";

export function BANNER_REQUEST(state) {
  state;
  state.banners = {
    ...state.banners,
    isLoading: true
  };
}

const defaultBanners = {
  name: "-",
  description: "-",
  bannerType: "-",
  photoUrl: "-",
  promoId: "-"
};
export function BANNER_SUCCESS(state, payload) {
  const data = [];
  payload.data.data.rows.map(item => {
    const value = {
      id: item._id,
      name: item.name,
      description: item.description,
      bannerType: item.bannerType,
      photoUrl: item.photoUrl,
      promoId: item.promoId
    };
    data.push(_.defaultsDeep(_.omitBy(value, _.isNull), defaultBanners));
    return item;
  });

  state;
  state.banners = {
    ...state.banners,
    data: data,
    count: payload.data.data.count,
    status: payload.status,
    isLoading: false
  };
}
export function BANNER_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function GET_BANNER_REQUEST(state) {
  state;
  state.banner = {
    ...state.banner,
    isLoading: true
  };
}
export function GET_BANNER_SUCCESS(state, payload) {
  const data = {
    id: getValue(payload.data, 'id', null),
    name: getValue(payload.data, 'name', ''),
    description: getValue(payload.data, 'description', ''),
    bannerType: getValue(payload.data, 'bannerType', null),
    promo: getValue(payload.data, 'promo._id', null),
    photoUrl: getValue(payload.data, 'photoUrl', '')
  }
  state;
  state.banner = {
    isLoading: false,
    data: data,
    status: payload.status
  };
}
export function GET_BANNER_ERROR(state, payload) {
  state;
  state.banner = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function CREATE_BANNER_REQUEST(state) {
  state;
  state.banner = {
    ...state.banner,
    isLoading: true
  };
}
export function CREATE_BANNER_SUCCESS(state, payload) {
  state;
  state.banners = {
    ...state.banners,
    data: state.banners.data.map(item => {
      if (item.id === payload.bannerId) {
        return Object.assign({}, item, payload);
      }
      return item;
    }),
    isLoading: false,
    status: 200
  };
}
export function CREATE_BANNER_ERROR(state, payload) {
  state;
  state.banner = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function EDIT_BANNER_REQUEST(state) {
  state;
  state.banner = {
    ...state.banner,
    isLoading: true
  };
}
export function EDIT_BANNER_SUCCESS(state, payload) {
  state;
  state.banners = {
    ...state.banners,
    data: state.banners.data.map(item => {
      if (item.id === payload.bannerId) {
        return Object.assign({}, item, payload);
      }
      return item;
    }),
    isLoading: false,
    status: 200
  };
}
export function EDIT_BANNER_ERROR(state, payload) {
  state;
  state.banner = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function DELETE_BANNER_REQUEST(state) {
  state;
  state.banners = {
    ...state.banners,
    isLoading: true
  };
}
export function DELETE_BANNER_SUCCESS(state, payload) {
  let index = state.banners.data.findIndex(item => item.id == payload);
  state.banners.data.splice(index, 1);
  state;
  state.banners = {
    ...state.banners,
    isLoading: false,
    data: state.banners.data
  };
}
export function DELETE_BANNER_ERROR(state, payload) {
  state;
  state.banners = {
    ...state.banners,
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}
